import styled from 'styled-components'
import { MdClose } from 'react-icons/md'

export const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  /* @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 36px;
    height: 36px;
    top: 60px;
  }
   ; */
`

export const SwitchModalContainer = styled.div`
  width: 100%;
  position: relative;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    /* width: 100%; */
    height: 70%;
  }
`
export const SwitchModalBackground = styled.div`
  width: 500px;
  background: ${({ theme }) => theme.colors.white};
  z-index: 15000000000000;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    /* top: 100px; */
    /* border-radius: 40px 40px 0px 0px; */

    /* height: 70%; */
  }
`

export const SwitchPaymentWrapper = styled.div`
  width: 450px;
  height: 100vh;
  padding: 30px 30px;
  background-color: white;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.4);

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: -webkit-fill-available;
    padding: 30px 20px;
    // border-radius: 40px 40px 0px 0px;
    position: absolute;
    // top: 180px;
    right: 0;
  }
`
